
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

export default function Footer() {
  const [popularTags, setPopularTags] = useState<Array<{tag: string, count: number}>>([]);

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Links', href: '/links' },
    { name: '記事', href: '/blog' },
    { name: 'Forum', href: '/forum' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  const legalLinks = [
    // 削除: { name: 'suoh', href: 'https://note.com/suoh2009', external: true }
  ];

  // 人気タグを取得
  useEffect(() => {
    const fetchPopularTags = async () => {
      try {
        const { data, error } = await supabase
          .from('blogs')
          .select('tags')
          .not('tags', 'is', null);

        if (error) {
          console.error('Tags fetch error:', error);
          return;
        }

        // タグの使用頻度を集計
        const tagCounts: Record<string, number> = {};
        
        data?.forEach(blog => {
          if (blog.tags && Array.isArray(blog.tags)) {
            blog.tags.forEach(tag => {
              if (tag && tag.trim()) {
                const cleanTag = tag.trim();
                tagCounts[cleanTag] = (tagCounts[cleanTag] || 0) + 1;
              }
            });
          }
        });

        // 使用頻度順にソートして上位8つを取得
        const sortedTags = Object.entries(tagCounts)
          .map(([tag, count]) => ({ tag, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 8);

        setPopularTags(sortedTags);
      } catch (error) {
        console.error('Error fetching popular tags:', error);
      }
    };

    fetchPopularTags();

    // リアルタイム更新の設定
    const subscription = supabase
      .channel('blogs_tags_changes')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'blogs' },
        () => fetchPopularTags()
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-information-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-gray-900 dark:text-white">斎藤元彦まとめ</span>
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-4 max-w-md">
              斎藤元彦をはじめとする兵庫県政問題のポータルサイトです。最新の動向にキャッチアップしてゆきます。
            </p>
            <div className="flex space-x-4">
              <a href="https://x.com/suoh2009" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer">
                <i className="ri-rss-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">
              作成者について
            </h3>
            <div className="space-y-2">
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                金融システムを熟知する投資家 兼 ITコンサル。<br />
                仕事と趣味どっちもハードワークになりがち。
              </p>
              <div className="flex space-x-3 mt-3">
                <a 
                  href="https://x.com/suoh2009" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                  title="X (Twitter)"
                >
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
                <a 
                  href="https://note.com/suoh2009" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                  title="note"
                >
                  <i className="ri-article-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-4 text-sm text-gray-600 dark:text-gray-400">
              <span>&copy; 2025 斎藤元彦まとめ. All rights reserved.</span>
              <span className="hover:text-gray-900 dark:hover:text-white">
                Made by suoh
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
